import { FormattedMessage } from 'react-intl';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { Props as PickerProps } from '#src/components/missions/picker/PickerOnboardingDialog/index.tsx';
import { PickerOnboardingDialog } from '#src/components/missions/picker/PickerOnboardingDialog/index.tsx';

import fiat from './assets/fiat.webp';
import icons from './assets/icons.webp';
import dailyMissionsMarqueeImgBottom from './assets/tape-daily-bw.webp';
import dailyMissionsMarqueeImgTop from './assets/tape-daily-color.webp';
import vaultMissionsMarqueeImgBottom from './assets/tape-vault-bw.webp';
import vaultMissionsMarqueeImgTop from './assets/tape-vault-color.webp';
import dialogBg from './assets/vault-mission-onboarding-bg.webp';
import xp from './assets/xp.webp';

type Props = {
  isVaultMission?: boolean;
  onClose: () => void;
};

const footballProps = {
  leftImg: xp,
  rightImg: xp,
  mobileImg: xp,
  iconsImg: icons,
  greenText: (
    <FormattedMessage defaultMessage="Win 200XP per successful pick!" />
  ),
  mainText: <FormattedMessage defaultMessage="Pick 3 Players" />,
  secondaryText: <FormattedMessage defaultMessage="Can They Hit a Decisive?" />,
  captionText: (
    <FormattedMessage defaultMessage="Scarcity of XP based on Card scarcity" />
  ),
} as Omit<PickerProps, 'onClose'>;

const nbaProps = {
  leftImg: fiat,
  rightImg: fiat,
  mobileImg: fiat,
  greenText: <FormattedMessage defaultMessage="Win Cash!" />,
  secondaryText: <FormattedMessage defaultMessage="Can They GET IT DONE?" />,
} as Omit<PickerProps, 'onClose'>;

const dailyOrVaultProps = {
  daily: {
    mainText: <FormattedMessage defaultMessage="Pick 3 Players" />,
    marqueeImgTop: dailyMissionsMarqueeImgTop,
    marqueeImgBottom: dailyMissionsMarqueeImgBottom,
  },
  vault: {
    dialogBg,
    mainText: <FormattedMessage defaultMessage="Pick 3 sealed Players" />,
    marqueeImgTop: vaultMissionsMarqueeImgTop,
    marqueeImgBottom: vaultMissionsMarqueeImgBottom,
  },
};

export const DecisivePlayerPickerOnboardingDialog = ({
  isVaultMission = false,
  onClose,
}: Props) => {
  const { sport } = useSportContext();
  const propsBySport = {
    [Sport.FOOTBALL]: footballProps,
    [Sport.NBA]: nbaProps,
    [Sport.BASEBALL]: nbaProps,
  };

  return (
    <PickerOnboardingDialog
      onClose={onClose}
      {...propsBySport[sport]}
      {...(isVaultMission ? dailyOrVaultProps.vault : dailyOrVaultProps.daily)}
    />
  );
};
